// extracted by css-extract-rspack-plugin
export default {"cls1":"OffsiteAuthorCard-cls1_Sk4","cls2":"OffsiteAuthorCard-cls2_ZIn OffsiteAuthorCard-cls1_Sk4"};